import { render, staticRenderFns } from "./ProductCategoryUpdate.vue?vue&type=template&id=2de96ae9&scoped=true"
import script from "./ProductCategoryUpdate.vue?vue&type=script&lang=js"
export * from "./ProductCategoryUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de96ae9",
  null
  
)

export default component.exports